// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__P8hhe","footer":"ModalFilter_footer__3hkc2"};